import {StyleSheet} from "react-native";
import {styleVars} from "../../app-style-vars";

export default StyleSheet.create({
  titleContainer: {
    paddingHorizontal: styleVars.rem(1)
  },
  toggleHeaderContainer: {
    flexDirection:'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  headerText: {
    fontSize: styleVars.rem(1.25),
    fontWeight: 'bold'
  },
  dataItemContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: styleVars.rem(.5),
    paddingVertical: styleVars.rem(.25),
  },
  dataItemLabel: {
    paddingHorizontal: styleVars.rem(.5)
  },
  dataItemValue: {
    paddingHorizontal: styleVars.rem(.5),
  },
  addressValue: {
    flex: 1
  },
  noAuthText: {
    padding: styleVars.rem(.25),
    textAlign: 'center',
    fontSize: styleVars.rem(.625),
  }
})